<template>
  <div>
    <v-card color="cardbackground">
      <v-card-title class="pt-2">
        Egg
      </v-card-title>
      <v-card-text>
        <v-btn
          block
          color="primary"
          :disabled="!isOnline || disabled"
          @click="openMainDialog()">
          <v-icon class="mr-2">mdi-upload</v-icon>
           Upload
        </v-btn>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="showMainDialog"
      max-width="800px"
      transition="dialog-bottom-transition"
      persistent>
      <v-card min-height="635px" color="cardbackground">
        <v-card-text class="pa-4">
          <v-form ref="form" v-model="isUploadFormValid">
            <div class="d-flex mb-2">
              <div>
                <div class="text-h4">Egg</div>
                <div class="pl-1 text-subtitle-1">
                  File Upload <v-icon color="primary" @click="showInfo()" style="padding-bottom:2px">mdi-help-circle-outline</v-icon>
                </div>
              </div>
              <v-spacer />
              <v-btn fab @click="closeMainDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card>
              <v-card-text class="pa-4">
                <v-card class="py-1 px-4 mb-2">
                  <div class="mb-5 d-flex flex-wrap overflow-y-auto overflow-x-hidden">
                    <v-text-field
                      v-model="farm"
                      readonly
                      class="mr-2"
                      style="max-width: 50px;"
                      label="Farm"
                    />
                    <v-select
                      :disabled="!farm"
                      v-model="house"
                      clearable
                      class="mr-2"
                      style="max-width: 125px;"
                      label="House"
                      @change="loadCsvFile()"
                      :items="farmHouses"
                      :rules="[rules.required]"
                    />
                    <v-select
                      :disabled="!farm"
                      v-model="line"
                      clearable
                      class="mr-2"
                      style="max-width: 102px;"
                      label="Line"
                      @change="mg=null; loadCsvFile()"
                      :items="farmLines"
                      :rules="[rules.required]"
                    />
                    <v-select
                      :disabled="!line"
                      v-model="mg"
                      clearable
                      class="mr-2"
                      style="max-width: 102px;"
                      label="MG"
                      @change="loadCsvFile()"
                      :items="farmLineMgs"
                      :rules="[rules.required]"
                    />
                    <!-- <v-text-field
                      class="ml-2 mt-1"
                      v-model="search"
                      clearable
                      label="Search"
                      type="text"
                      prepend-icon="mdi-magnify"
                    /> -->
                    <v-text-field
                      clearable
                      v-model="notes"
                      @keypress="allowAlphaNumOnly($event)"
                      @keyup="notes = toAlphaNumOnly(notes)"
                      label="Notes"
                    />
                  </div>
                  <div class="d-flex flex-wrap">
                    <v-file-input
                      style="width: 300px;"
                      :truncate-length="40"
                      label="Egg CSV File"
                      accept=".csv"
                      :error="!!errorMessage"
                      :error-messages="errorMessage"
                      :clearable="true"
                      outlined dense autofocus
                      :large="$vuetify.breakpoint.xs ? false : true"
                      @change="loadCsvFile(); $refs.form.validate();"
                      v-model="csvEggFile"
                    />
                    <v-btn
                      class="py-5 ml-4"
                      color="primary"
                      :disabled="eggRows.length < 1 || !!errorMessage || !farm || !isUploadFormValid"
                      @click="uploadEggData()"
                    >
                      <v-icon>mdi-upload</v-icon>
                      <div v-show="$vuetify.breakpoint.xs ? false : true">
                        Upload
                      </div>
                    </v-btn>
                  </div>
                  <v-data-table
                    dense
                    class="cardbackground"
                    fixed-header
                    :search="search"
                    :headers="columnHeaders"
                    :items="eggRows"
                    no-data-text="No Data Available">

                    <template v-slot:body="{ items }" >
                      <tbody>
                        <tr v-for="(item) in items" :key="item.index" :style="item.status ? 'background-color:orange' : ''">
                          <td>{{ item.index }}</td>
                          <td>{{ item.Wingband }}</td>
                          <td>{{ item.Grade }}</td>
                          <td>{{ item.Operator }}</td>
                          <td>{{ item.Date }}</td>
                          <td>{{ item.Time }}</td>
                          <td>{{ item.status }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>
      </v-card>
      <v-overlay :value="isBusy">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <v-dialog
      v-model="showInfoDialog"
      max-width="400px"
      transition="dialog-bottom-transition"
      persistent>
      <v-card color="cardbackground">
        <v-card flat min-height="500px" color="cardbackground">
          <v-tabs v-model="tab">
            <v-tab class="ma-2">File Upload</v-tab>
            <v-tab class="ma-2">Grades</v-tab>
          </v-tabs>
  
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-card flat color="cardbackground">
                <v-card-text class="px-4">
                  <div>
                    <p>Egg Grades can be manually uploaded for a specified farm/line/mg via a csv file
                    that is formatted as follows:</p>
                    <p><img src="@/assets/img/UploadCsvTemplate.png" /></p>
                    <p>Once the csv file has been created, it can be attached
                      <img style="margin-top:10px; width:340px" src="@/assets/img/AttachCsvFile.png" /> from the
                      <i>Egg CSV Upload Dialog</i> and the data will be validated. If valid, the upload button is
                      enabled allowing the data to be uploaded into the 'Egg Picker' database.
                    </p>
                    <p class="pb-0 mb-0">To download the template click here:<br />
                      <ul><li><a @click="downloadUploadTemplate()"><u>Download Egg CSV Template</u></a></li></ul>
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat color="cardbackground" style='min-height:550px'>
                <v-card-text>
                  <p>The Codes shown below are the valid grades which can be specified in the csv upload file.
                     The Description column is provided as a reference.
                  </p>
                  <v-radio-group
                    v-model="category"
                    class="ml-12"
                    row
                  >
                    <v-radio label="Pedigree" class="mr-10" value="Pedigree"></v-radio>
                    <v-radio label="Super Sister" value="Super Sister"></v-radio>
                  </v-radio-group>

                  <v-simple-table dense class="ml-10" style="width:75%">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th color="primary" class="text-left">Code</th>
                          <th class="text-left">Description</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in eggGrades" :key="item.name">
                          <td>{{ item.code }}</td>
                          <td>{{ item.descr }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items> 
        </v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn
            large
            color="secondary"
            class="mb-2 mr-2"
            @click="showInfoDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eggApi from "../api/eggApi";
import { mapState } from "vuex";
import fileApi from "../api/fileApi";
import OfflineStorage from "../utils/offlineStorage";
import eggPickerConstants from "../utils/eggPickerConstants";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  async created() {
    this.rules = { ...this.$root.validationRules };
    this.farm = this.settings.currentFarm;
    this.allMgs = await eggApi.getMiniGenList();
    this.deviceName = await OfflineStorage.getItem("deviceName");
  },
  data() {
    return {
      category: "Pedigree",
      tab: null,
      isBusy: false,
      showInfoDialog: false,
      errorMessage: null,
      csvEggFile: null,
      eggRows: [],
      rules: null,
      search: "",
      notes: "",
      showMainDialog: false,
      allMgs: [],
      farm: null,
      line: null,
      house: null,
      mg: null,
      isUploadFormValid: false,
    };
  },
  computed: {
    ...mapState(["settings", "isOnline"]),
    columnHeaders() {
      return [
        {
          text: "Row",
          value: "index",
          sortable: true,
          class: "cardbackground",
        },
        {
          text: "Wingband",
          value: "Wingband",
          sortable: true,
          class: "cardbackground",
        },
        {
          text: "Grade",
          value: "Grade",
          sortable: true,
          align: "center",
          class: "cardbackground",
        },
        {
          text: "Operator",
          value: "Operator",
          sortable: true,
          alighn: "center",
          class: "cardbackground",
        },
        {
          text: "Date",
          value: "Date",
          sortable: true,
          align: "center",
          class: "cardbackground",
        },
        {
          text: "Time",
          value: "Time",
          sortable: true,
          align: "center",
          class: "cardbackground",
        },
        {
          text: "Status",
          value: "status",
          sortable: true,
          align: "center",
          class: "cardbackground",
        },
      ];
    },
    eggGrades() {
      if (this.category === "Pedigree") {
        return this.settings.eggGrades.filter((e) => e.isPedigree);
      } else {
        return this.settings.eggGrades.filter((e) => e.isSuperSister);
      }
    },
    farms() {
      const farms = this.settings.farms.map((f) => f.farmCode);
      return farms;
    },
    farmHouses() {
      const houses = this.settings.farmHouses.map((h) => h.houseCode);
      houses.push({ text: "N/A", value: "N/A" });
      return houses;
    },
    farmLines() {
      let lineList = this.allMgs
        .filter((m) => m.farmCode === this.farm)
        .map((m) => m.lineCode);
      let uniqueLines = [...new Set(lineList)];
      let lines = uniqueLines.map((l) => ({
        text: `  L${l}`,
        value: l,
      }));
      lines.push({ text: "N/A", value: "N/A" });
      return lines;
    },
    farmLineMgs() {
      let mgList = this.allMgs
        .filter((m) => m.farmCode === this.farm && m.lineCode == this.line)
        .map((m) => m.miniGenerationNum)
        .sort((a, b) => (a < b ? 1 : -1));
      let uniqueMgs = [...new Set(mgList)];
      let mgs = uniqueMgs.map((l) => ({
        text: `  ${l}`,
        value: l,
      }));
      mgs.push({ text: "N/A", value: "N/A" });
      return mgs;
    },
  },
  methods: {
    allowAlphaNumOnly(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-z0-9 ]+$/.test(char)) return true; // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    toAlphaNumOnly(value) {
      if (value == null) return;
      value = value.toUpperCase();
      value = value.replace(/[^A-Z0-9\s!?]/g, "");
      return value;
    },
    closeMainDialog() {
      this.eggRows = [];
      this.csvEggFile = null;
      this.showMainDialog = false;
      this.errorMessage = null;
    },
    downloadUploadTemplate() {
      try {
        var csv =
          "Wingband,Grade,Operator,Date,Time\r\n" +
          "AAA1234,G,Joe Smith,01/01/2022,10:10:30,\r\n" +
          "BBB5678,S,Sue Jones,01/02/2022,13:00:00\r\n" +
          `${eggPickerConstants.FLOOR_EGG},O,John Doe,01/02/2022,13:25:00\r\n` +
          `${eggPickerConstants.NEST_EGG},M,John Doe,01/02/2022,13:26:00\r\n`;
        const fileName = `EggUploadTemplate.csv`;
        fileApi.downloadCsvLocal(fileName, csv);
      } catch (error) {
        this.$root.showNoticeError(error);
      }
    },
    async openMainDialog() {
      this.showMainDialog = true;
    },
    async loadCsvFile() {
      if (!this.csvEggFile) {
        this.eggRows = [];
        this.errorMessage = null;
        return;
      }
      var reader = new FileReader();

      reader.readAsText(this.csvEggFile);
      reader.onload = async () => {
        this.eggRows = this.convertCsv2Json(reader.result);
        if (this.eggRows.length === 0) {
          this.errorMessage = "Empty file.";
          return;
        }
        if (
          !this.checkHeaderExists("Wingband") ||
          !this.checkHeaderExists("Grade") ||
          !this.checkHeaderExists("Date") ||
          !this.checkHeaderExists("Operator") ||
          !this.checkHeaderExists("Time")
        ) {
          return;
        }
        await this.validateRows();
      };
    },
    checkHeaderExists(hdr) {
      if (this.eggRows.length < 1) return false;
      if (hdr in this.eggRows[0]) {
        return true;
      } else {
        this.eggRows = [];
        this.errorMessage = `Missing '${hdr}' column.`;
        return false;
      }
    },
    convertCsv2Json(data) {
      let lines = data.split("\r\n").filter((e) => e !== "");
      const header = lines[0].split(",");
      const json = lines.slice(1).map((line) => {
        const fields = line.split(",");
        return Object.fromEntries(header.map((h, i) => [h, fields[i]]));
      });
      this.removeEmptyRowsAtEnd(json);

      return json;
    },
    removeEmptyRowsAtEnd(objArray) {
      for (var i = objArray.length - 1; i >= 0; i--) {
        let row = objArray[i];
        for (const key in row) {
          if (row[key]) {
            return; // done removing empty rows at end of array;
          }
        }
        objArray.pop(); // remove empty row at end of array
      }
    },
    showInfo() {
      this.showInfoDialog = true;
    },
    async uploadEggData() {
      this.$refs.form.validate();
      if (!this.isUploadFormValid) return;

      if (this.isBusy) return; // avoid duplicate uploads (possible double click)
      this.isBusy = true;
      try {
        let eggs = [];
        this.eggRows.forEach((r) => {
          const rowOperator = r.Operator.toUpperCase().trim();
          const operator = this.settings.farmOperators.find(
            (o) => o.operatorName.toUpperCase() == rowOperator
          );
          const operatorId = operator.operatorId;
          //add badge for floor and nest eggs for api to insert correctly
          if (
            r.Wingband.toUpperCase() == eggPickerConstants.FLOOR_EGG ||
            r.Wingband.toUpperCase() == eggPickerConstants.NEST_EGG
          ) {
            eggs.push({
              wingband: r.Wingband,
              operatorId: operatorId,
              date: new Date(r.Date + " " + r.Time),
              grade: r.Grade,
              badge: r.Wingband, //NEST or FLOOR
            });
          } else {
            eggs.push({
              wingband: r.Wingband,
              operatorId: operatorId,
              date: new Date(r.Date + " " + r.Time),
              grade: r.Grade,
            });
          }
        });

        let payload = {
          deviceName: this.deviceName,
          clientUid: crypto.randomUUID(),
          date: new Date(),
          farm: this.farm,
          house: this.house,
          notes: !this.notes ? "csv upload" : "csv upload - " + this.notes,
          samples: eggs,
        };

        await eggApi.addEggGroup(payload);
        this.isBusy = false;
        this.$root.showNoticeSuccess(`Egg file uploaded successfully.`);
        this.eggRows = [];
        this.csvEggFile = null;
      } catch (error) {
        console.log(error); // eslint-disable-line no-console
        this.$root.showNoticeError(error.message);
        this.isBusy = false;
      }
    },
    isValidDate(s) {
      if (isNaN(s) && !isNaN(Date.parse(s))) return true;
      else return false;
    },
    isValidTime(s) {
      const regexp = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$/;
      if (regexp.test(s)) return true;
      else return false;
    },
    async validateRows() {
      let wingbandsInfo = await this.getWingbandsInfo();

      var pedigreeGrades = this.settings.eggGrades.filter((e) => e.isPedigree);
      var superSisterGrades = this.settings.eggGrades.filter(
        (e) => e.isSuperSister
      );

      try {
        this.isBusy = true;
        this.errorMessage = null;
        let errorFound = false;

        this.eggRows.map((row, i) => {
          row.index = i + 2;
          if (!this.settings.eggGrades.find((e) => e.code == row.Grade)) {
            row.status = `Invalid Grade.`;
            errorFound = true;
          } else if (!this.isValidDate(row.Date)) {
            row.status = `Invalid Date.`;
            errorFound = true;
          } else if (!this.isValidTime(row.Time)) {
            row.status = `Invalid Time.`;
            errorFound = true;
          } else if (
            !this.settings.farmOperators.find(
              (o) =>
                o.operatorName.toUpperCase() ==
                row.Operator.toUpperCase().trim()
            )
          ) {
            row.status = `Invalid Operator.`;
            errorFound = true;
          } else if (
            (row.Wingband.toUpperCase() == eggPickerConstants.FLOOR_EGG ||
              row.Wingband.toUpperCase() == eggPickerConstants.NEST_EGG) &&
            (this.house == null || this.house == "N/A")
          ) {
            row.status = `House Required.`;
            errorFound = true;
          } else if (!wingbandsInfo.find((w) => w.wingband == row.Wingband)) {
            row.status = `Invalid Wingband.`;
            errorFound = true;
          } else {
            var currentWingband = wingbandsInfo.find(
              (w) => w.wingband == row.Wingband
            );
            // check if grade is invalid
            var eggFilterGrades = currentWingband.isPedigree
              ? pedigreeGrades
              : superSisterGrades;
            if (!eggFilterGrades.find((e) => e.code == row.Grade)) {
              row.status = `Wrong grade for ${
                currentWingband.isPedigree
                  ? "a pedigree wingband"
                  : "non pedigree wingband"
              }`;
              errorFound = true;
            } else {
              row.Status = "";
            }
          }
        });
        if (errorFound)
          this.errorMessage =
            "Invalid data found. See 'Status' column for details.";
      } catch (error) {
        console.log(error); // eslint-disable-line no-console
        this.$root.showNoticeError(error.message);
      } finally {
        this.isBusy = false;
        this.eggRows = JSON.parse(JSON.stringify(this.eggRows));
      }
    },
    async getWingbandsInfo() {
      let uniqueWingbands = [];
      this.eggRows.forEach((r) => {
        if (
          r.Wingband.toUpperCase() != eggPickerConstants.FLOOR_EGG &&
          r.Wingband.toUpperCase() != eggPickerConstants.NEST_EGG
        ) {
          if (uniqueWingbands.indexOf(r.Wingband) == -1)
            uniqueWingbands.push(r.Wingband);
        }
      });

      const theHouse = this.house == "N/A" ? null : this.house;
      const theLine = this.line == "N/A" ? null : this.line;
      const theMg = this.mg == "N/A" ? null : this.mg;
      let wingbandsInfo = await eggApi.validateWingbands(
        this.farm,
        theHouse,
        theLine,
        theMg,
        uniqueWingbands
      );
      //append floor and nest values to help during validation
      wingbandsInfo.push({
        wingband: eggPickerConstants.FLOOR_EGG,
        isPedigree: false,
      });
      wingbandsInfo.push({
        wingband: eggPickerConstants.NEST_EGG,
        isPedigree: false,
      });
      return wingbandsInfo;
    },
  },
};
</script>